import { Client, Functions } from "appwrite";
import conf from "../conf/conf";
import { APPWRITE_PROMPT_FUNCTION_ID } from "../AppWrite/appwrite";

const client = new Client()
  .setEndpoint(conf.appwrite_url)
  .setProject(conf.appwrite_project_id);

const functions = new Functions(client);

const extractJSONObject = (text) => {
  if (typeof text !== "string") return null;

  // try 1: plain JSON
  try {
    return JSON.parse(text);
  } catch {}

  // try 2: strip code fences
  const cleaned = text.replace(/```json|```/gi, "").trim();
  try {
    return JSON.parse(cleaned);
  } catch {}

  // try 3: grab the first {...} block
  const m = cleaned.match(/\{[\s\S]*\}/);
  if (m) {
    try {
      return JSON.parse(m[0]);
    } catch {}
  }
  return null;
};
// -------------------------------------------

export const handlePrompt = async () => {
  try {
    const execution = await functions.createExecution(
      APPWRITE_PROMPT_FUNCTION_ID,
      JSON.stringify({
        prompt: `Generate exactly 10 unique and meaningful statements.  
Each statement must be 1–2 sentences long, concise, and clear.  
Do not overlap ideas between statements.  
Return ONLY a JSON array of strings (e.g. ["...", "..."]). No extra text.`,
      })
    );

    const body = execution?.responseBody ?? "";
    let parsed = Array.isArray(body) ? body : null;

    if (!parsed) {
      // handle cases where the function returns JSON text
      try {
        parsed = JSON.parse(body);
      } catch {
        // maybe wrapped with fences or contains logs
        parsed = extractJSONObject(body);
      }
    }

    const reply = Array.isArray(parsed)
      ? parsed
      : Array.isArray(parsed?.reply)
      ? parsed.reply
      : [];

    return { reply };
  } catch (error) {
    console.error("Error in handlePrompt:", error);
    return { reply: [] };
  }
};

export const handleParagraphPrompt = async () => {
  try {
    const execution = await functions.createExecution(
      APPWRITE_PROMPT_FUNCTION_ID,
      JSON.stringify({
        prompt: `Generate a short story of one paragraph between 60 - 80 words and five questions to answer from the paragraph.
Return ONLY JSON in this exact format: { "paragraph": "....", "questions": ["q1","q2","q3","q4","q5"] }`,
      })
    );

    const body = execution?.responseBody ?? "";

    // try to parse a JSON object from body
    let parsed = extractJSONObject(body) || {};

    // unwrap common wrappers: { reply: {...} }
    if (parsed?.reply && typeof parsed.reply === "object") {
      parsed = parsed.reply;
    }

    // normalize
    const paragraph =
      typeof parsed.paragraph === "string" ? parsed.paragraph : "";
    const questions = Array.isArray(parsed.questions)
      ? parsed.questions.filter((q) => typeof q === "string").slice(0, 5)
      : [];

    return { paragraph, questions };
  } catch (error) {
    console.error("Error in handleParagraphPrompt:", error);
    return { paragraph: "", questions: [] };
  }
};
